// RoomCanvas.jsx
import React from "react";
import Room from "./Room";
import Wall from "./Wall";

const RoomCanvas = ({ rooms, setRooms, selectedId, setSelectedId }) => {
  const handleSelect = (id) => () => {
    setSelectedId(id);
  };

  const handleChange = (newAttrs) => {
    const updated = rooms.map((room) =>
      room.id === newAttrs.id ? newAttrs : room
    );
    setRooms(updated);
  };

  return (
    <>
      {rooms.map((room) => {
        const isSelected = room.id === selectedId;
        if (room.type === "wall") {
          return (
            <Wall
              key={room.id}
            shapeProps={room}
            isSelected={isSelected}
            onSelect={() => {
              handleSelect(room.id)();
            }}
            onChange={handleChange}
            isFreeSize={room.isFreeSize}
            strokeWidth={room.strokeWidth}
            />
          );
        }
        return (
          <Room
            key={room.id}
            shapeProps={room}
            isSelected={isSelected}
            onSelect={() => {
              handleSelect(room.id)();
            }}
            onChange={handleChange}
            isFreeSize={room.isFreeSize}
          />
        );
      })}
    </>
  );
};

export default RoomCanvas;
